/* Mairaz hero - desktop-only slide handling.

   WHAT COUNTS AS DESKTOP-ONLY
   A hero slide with no mobile image has nothing to show below 750px: the
   section only emits a <source media="(max-width: 749px)"> element when the
   slide has an image_mobile set. A slide missing that source is therefore
   carrying landscape campaign artwork with no mobile counterpart, and must
   not appear on mobile at all.

   WHAT THIS DOES
   Below 750px it removes those slides and their navigation dots from the DOM
   before the carousel initialises, then re-indexes what remains. The
   carousel builds its slide list from the corrected DOM, so autoplay,
   arrows, dots, swipe, keyboard and the progress bar all cycle only the
   slides a visitor can actually see. No blank slide can appear and the dot
   count always matches the slide count.

   ORDERING
   Loaded from a section placed immediately after the hero, so the hero
   markup is already parsed but DOMContentLoaded - which is when the carousel
   initialises - has not fired yet.

   RESIZE
   Slide counts are fixed at page load. Crossing the 750px breakpoint by
   resizing a window does not re-add the slide until reload. That is
   deliberate: it keeps the carousel state machine simple and avoids leaving
   autoplay stranded on a hidden slide. Real devices do not cross this
   breakpoint mid-session.
*/
(function () {
  function prune() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll('[data-mrz-hero]').forEach(function (root) {
      var slides = Array.prototype.slice.call(
        root.querySelectorAll('[data-mrz-hero-slide]')
      );
      var dots = Array.prototype.slice.call(
        root.querySelectorAll('[data-mrz-hero-dot]')
      );

      if (slides.length < 2) return;

      slides.forEach(function (slide, i) {
        var hasMobile = slide.querySelector('picture source[media]');
        if (hasMobile) return;
        if (dots[i]) dots[i].remove();
        slide.remove();
      });

      var keptSlides = Array.prototype.slice.call(
        root.querySelectorAll('[data-mrz-hero-slide]')
      );
      var keptDots = Array.prototype.slice.call(
        root.querySelectorAll('[data-mrz-hero-dot]')
      );

      if (!keptSlides.length) return;

      keptSlides.forEach(function (slide, i) {
        slide.dataset.index = String(i);
        slide.classList.toggle('is-active', i === 0);
        if (slide.hasAttribute('aria-label')) {
          slide.setAttribute('aria-label', i + 1 + ' of ' + keptSlides.length);
        }
      });

      keptDots.forEach(function (dot, i) {
        dot.dataset.index = String(i);
        dot.classList.toggle('is-active', i === 0);
        dot.setAttribute(
          'aria-label',
          'Go to slide ' + (i + 1) + ' of ' + keptDots.length
        );
        if (i === 0) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      root.dataset.slideCount = String(keptSlides.length);
    });
  }

  prune();
  document.addEventListener('shopify:section:load', prune);
})();

/* Mairaz homepage - make key editorial section headings proper links. */
(function () {
  var destinations = [
    {
      selector: '[id$="__mairaz_instagram_reels_personalized"] .mrz-reels__heading',
      path: 'collections/shop-instagram',
      label: 'Open Shop Instagram'
    },
    {
      selector: '[id$="__new_arrivals"] h2.title',
      path: 'collections/new-arrivals',
      label: 'Open New Arrivals'
    },
    {
      selector: '[id$="__mairaz_best_sellers"] .mrz-bs__heading',
      path: 'collections/best-sellers',
      label: 'Open Best Sellers'
    }
  ];

  function localizedUrl(path) {
    var cleanPath = String(path || '').replace(/^\/+/, '');
    var cartUrl = window.routes && typeof window.routes.cart_url === 'string'
      ? window.routes.cart_url.split('?')[0]
      : '';
    var root = cartUrl ? cartUrl.replace(/cart(?:\.js)?\/?$/, '') : '/';

    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    return root + cleanPath;
  }

  function ensureStyles() {
    if (document.getElementById('MairazHomeSectionLinkStyles')) return;

    var style = document.createElement('style');
    style.id = 'MairazHomeSectionLinkStyles';
    style.textContent =
      '.mrz-home-section-link{color:inherit;display:inline-block;text-decoration:none;transition:opacity .18s ease;}' +
      '.mrz-home-section-link:focus-visible{outline:1px solid currentColor;outline-offset:.18em;}' +
      '@media (hover:hover) and (pointer:fine){.mrz-home-section-link:hover{opacity:.68;}}';
    document.head.appendChild(style);
  }

  function linkHeading(config) {
    var heading = document.querySelector(config.selector);
    if (!heading || heading.querySelector('a[href]')) return;

    var link = document.createElement('a');
    link.className = 'mrz-home-section-link';
    link.href = localizedUrl(config.path);
    link.setAttribute('aria-label', config.label);

    while (heading.firstChild) link.appendChild(heading.firstChild);
    heading.appendChild(link);
  }

  function enhanceHomepageHeadings() {
    ensureStyles();
    destinations.forEach(linkHeading);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceHomepageHeadings);
  } else {
    enhanceHomepageHeadings();
  }

  document.addEventListener('shopify:section:load', enhanceHomepageHeadings);
})();
